import React from 'react';
import { ServiceFilters } from '../../../../app/models/Service';
import { PurchaseDocumentFilters } from '../../../../app/models/PurchaseDocument';

type Props = {
    filter: PurchaseDocumentFilters;
    setFilter: (filter: PurchaseDocumentFilters) => void;
};

const ServiceFilter = ({ filter, setFilter }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    
    const handlerSelectFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };


    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="id">
                            ID
                        </label>
                        <input
                            title="Nro de Documento"
                            type="text"
                            id="id"
                            name="id"
                            className="form-control form-control-sm"
                            value={filter.id}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="document_number">
                            Nro de Documento
                        </label>
                        <input
                            title="Nro de Documento"
                            type="text"
                            id="document_number"
                            name="document_number"
                            className="form-control form-control-sm"
                            value={filter.document_number}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <label htmlFor="selectGrande" className="mb-1 font-size-10 ">Estado</label>
                    <select                 
                        name="status"
                        className="form-select form-select-sm"
                        value={filter.status}
                        onChange={(e) => handlerSelectFilter(e)}
                    >
                        <option key={''} value="">
                            Todos
                        </option>
                        <option key={'BORRADOR'} value="BORRADOR">
                            Borrador
                        </option>
                        {/* <option key={'ANULADA'} value="ANULADA">
                        Anulada
                        </option> */}
                        <option key={'CONTABILIZADA'} value="CONTABILIZADA">
                            Contabilizada
                        </option>
                    </select>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="society">
                            Sociedad
                        </label>
                        <input
                            title="Sociedad"
                            type="text"
                            id="society"
                            name="society"
                            className="form-control form-control-sm"
                            value={filter.society}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="provider">
                            Proveedor
                        </label>
                        <input
                            title="Proveedor"
                            type="text"
                            id="provider"
                            name="provider"
                            className="form-control form-control-sm"
                            value={filter.provider}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
            </div>

            <div className="row">
                
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_from">
                            Fecha emisión factura desde
                        </label>
                        <input
                            title="Fecha emisión factura desde"
                            type="date"
                            id="issue_date_from"
                            name="issue_date_from"
                            className="form-control form-control-sm"
                            value={filter.issue_date_from ?? ''}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_until">
                            Fecha emisión factura hasta
                        </label>
                        <input
                            title="Fecha emisión factura hasta"
                            type="date"
                            id="issue_date_until"
                            name="issue_date_until"
                            className="form-control form-control-sm"
                            value={filter.issue_date_until ?? ''}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <label htmlFor="selectGrande" className="mb-1 font-size-10 ">Tipo de Documento</label>
                    <select                         
                        name="document_type"
                        className="form-select form-select-sm"
                        value={filter.document_type}
                        onChange={(e) => handlerSelectFilter(e)}
                    >
                        <option key={''} value="">
                            Todos
                        </option>
                        <option key={'FACTURA'} value="FACTURA">
                            Factura electrónica
                        </option>
                        <option key={'NOTA_CREDITO'} value="NOTA_CREDITO">
                            Nota de Crédito electrónica
                        </option>
                        <option key={'NOTA_DEBITO'} value="NOTA_DEBITO">
                            Nota de Débito electrónica
                        </option>
                    </select>
                </div>

                <div className="col-md-auto">
                    <label htmlFor="selectGrande" className="mb-1 font-size-10 ">Moneda</label>
                    <select                         
                        name="currency"
                        className="form-select form-select-sm"
                        value={filter.currency}
                        onChange={(e) => handlerSelectFilter(e)}
                    >
                        <option key={''} value="">
                            Todas
                        </option>
                        <option key={'CLP'} value="CLP">
                            CLP
                        </option>
                        <option key={'USD'} value="USD">
                            USD
                        </option>
                        <option key={'UF'} value="UF">
                            UF
                        </option>
                        <option key={'EUR'} value="EUR">
                            EUR
                        </option>
                    </select>
                </div>

            </div>
        </div>

        
    );
};

export default ServiceFilter;
